export function lowerCase(string) {
    return string.toLowerCase()
}

export const dataForEventTypesTable = ({ messages, fields }) => {

    /**to get first level fields of event types along with the field type in brackets */
    const eventTypes = messages.map(item => {

        let fieldsAndType = []
        const eventTypeFields = fields.filter(field => field.parent[0].id === item._id);

        eventTypeFields.forEach(field => {
            const type = lowerCase(field.attributes.type);
            const messageAsType = messages.find(item => item._id == type);
            const requiredValue = `${field.name}(${messageAsType ? messageAsType.name : type})`;
            fieldsAndType.push(requiredValue)
        })

        item.fields = fieldsAndType;

        return item;
    })

    const alphabeticallyArrangedList = eventTypes.sort(function (a, b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    })

    return alphabeticallyArrangedList;
}